<template>
  <div class="user-quota">
        <div class="boxed">
            <h3>{{ Language.say('user_dashboard.usage') }}</h3>
            <div class="progressbar">
                <div :class='`bar more-than${mailbox_quota.storage_percentage_floor}`' :style="`width: ${mailbox_quota.storage_percentage_bar}%`"></div>
            </div>
			<div class="info">
				<p>
				{{ Language.say('user_dashboard.usage_1') }}
				{{ mailbox_quota.storage_used_gb }} GB
				{{ Language.say('user_dashboard.usage_2') }}
				{{ mailbox_quota.storage_virtual_gb }} GB ({{ mailbox_quota.storage_virtual_percentage }}%)
				</p>
			</div>

			<div class="info" v-if="AccountController.account.premium.allowed === true">
				<div class="info" v-if="mailbox_quota.storage_percentage <= 99 && AccountController.account.premium.enabled !== true">
					<div class="upgrade">
						<p>{{ Language.say('user_dashboard.more_space_1') }}</p>
						<LinkButton
							:link="links.premium"
							:text="'user_dashboard.upgrade_premium'"
							class='main-action'
							target="_blank"
							:gtm="{
								module : 'user_dashboard',
								feature: 'user_quota',
								block  : 'quota_warning',
								action : 'premium_subscribe'
							}"
						/>
					</div>
					<br>
				</div>
			</div>

			<div class="info" v-if="mailbox_quota.storage_percentage >= 99">
				<div class="upgrade">
					<p>{{ Language.say('user_dashboard.overquota_1') }}</p>
					<p><strong>{{ Language.say('user_dashboard.overquota_2') }}</strong> {{ Language.say('user_dashboard.overquota_3') }} </p>
					<p>{{ Language.say('user_dashboard.overquota_4') }} <router-link to="/settings/housekeeper">{{ Language.say('user_dashboard.overquota_5') }}</router-link> {{ Language.say('user_dashboard.overquota_6') }}</p>

				</div>
			</div>

			<div class="info" v-else-if="mailbox_quota.storage_virtual_percentage >= 99">
				<div class="upgrade">
					<p>{{ Language.say('user_dashboard.overquota_virtual_1') }}
					<strong>{{ Language.say('user_dashboard.overquota_virtual_2') }}</strong> </p>
					<p>{{ Language.say('user_dashboard.overquota_virtual_4') }} <router-link to="/settings/housekeeper">{{ Language.say('user_dashboard.overquota_virtual_5') }}</router-link> {{ Language.say('user_dashboard.overquota_virtual_6') }}</p>

				</div>
			</div>
      </div>
    </div>
</template>
<script setup>
  import {reactive}          from 'vue';
  import MailboxController   from '@/js/Mailboxes/MailboxController.js';
  import Language            from '@/js/Shared/Language/Language';
  import LinkButton          from '@/vue/Elements/Buttons/LinkButton.vue';
  import AccountController   from '@/js/Webmail/AccountController';
  import SAPOMailConfig      from '@/SAPOMailConfig';

  const links         = SAPOMailConfig.server.external_links;
  const mailbox_quota = reactive(MailboxController).quota;

  window.changeQuota = (value) => {
	mailbox_quota.storage_used = value * 1024 * 1024 * 1024;
    mailbox_quota.storage_percentage       = mailbox_quota.storage_limit > 0 ? (mailbox_quota.storage_used / mailbox_quota.storage_limit) * 100 : 0;
    mailbox_quota.storage_percentage       = Math.round(mailbox_quota.storage_percentage * 10) / 10;

    mailbox_quota.storage_virtual_percentage = mailbox_quota.storage_virtual > 0 ? (mailbox_quota.storage_used / mailbox_quota.storage_virtual) * 100 : 0;
    mailbox_quota.storage_virtual_percentage = Math.round(mailbox_quota.storage_virtual_percentage * 10) / 10;
    mailbox_quota.storage_percentage_bar = mailbox_quota.storage_virtual_percentage > 100 ? 100 : mailbox_quota.storage_virtual_percentage;

    if ( mailbox_quota.storage_virtual_percentage >= 90) {
      mailbox_quota.storage_percentage_floor = 90;
    } else if (mailbox_quota.storage_virtual_percentage >= 70) {
      mailbox_quota.storage_percentage_floor = 70;
    } else if (mailbox_quota.storage_virtual_percentage >= 50) {
      mailbox_quota.storage_percentage_floor = 50;
    } else if (mailbox_quota.storage_virtual_percentage >= 30) {
      mailbox_quota.storage_percentage_floor = 30;
    } else {
      mailbox_quota.storage_percentage_floor = 0;
    }
  }
</script>